module.exports = __webpack_public_path__ + "img/growcify-website-10-banner.3b14eb93.png";